import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';

class CapcitorAppRefreshService {
    // Using Subject so subscriber only gets values once they subscribe
    capacitorAppRefreshSubject = new Subject();
    // Expose the observable$ but keep the subject private
    capacitorAppRefreshSubject$ = this.capacitorAppRefreshSubject.asObservable();
    constructor() { }
    /**
     * Set the boolean value
     * @param value - The new boolean value
     */
    setlockCapacitorAppRefresh(value) {
        this.capacitorAppRefreshSubject.next(value);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CapcitorAppRefreshService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CapcitorAppRefreshService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CapcitorAppRefreshService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class CapacitorAppRefreshModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CapacitorAppRefreshModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CapacitorAppRefreshModule, imports: [CommonModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CapacitorAppRefreshModule, providers: [CapcitorAppRefreshService], imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CapacitorAppRefreshModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [CommonModule],
                    providers: [CapcitorAppRefreshService],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CapacitorAppRefreshModule, CapcitorAppRefreshService };
